import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../context/AuthContext'

const REMINDER_TYPES = [
  { value: 'deadline', label: '📅 Filing Deadline', desc: 'Remind client of their tax filing deadline' },
  { value: 'document', label: '📄 Documents Needed', desc: 'Ask client to upload missing documents' },
  { value: 'organizer', label: '📋 Complete Organizer', desc: 'Remind client to complete their tax organizer' },
  { value: 'invoice', label: '🧾 Invoice Due', desc: 'Remind client of an outstanding invoice' },
  { value: 'custom', label: '✏️ Custom Message', desc: 'Write your own reminder message' },
]

const EMAIL_TEMPLATES = {
  deadline: (clientName, details) => ({
    subject: `Important: Your Tax Filing Deadline is Approaching`,
    html: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px;">
        <div style="background: #202326; padding: 24px; border-radius: 8px 8px 0 0; text-align: center;">
          <h1 style="color: #CBB17B; margin: 0; font-size: 24px;">ClearFile Portal</h1>
          <p style="color: rgba(255,255,255,0.6); margin: 4px 0 0; font-size: 13px;">Midpoint Accounting Group Co.</p>
        </div>
        <div style="background: #fff; border: 1px solid #e2e8f0; border-top: none; padding: 32px; border-radius: 0 0 8px 8px;">
          <h2 style="color: #202326; margin-top: 0;">Hello ${clientName},</h2>
          <p style="color: #4a5568; line-height: 1.6;">This is a friendly reminder that your tax filing deadline is approaching. Please ensure all required documents have been uploaded to your ClearFile portal.</p>
          ${details ? `<div style="background: #F1E8D7; border-left: 4px solid #CBB17B; padding: 12px 16px; margin: 20px 0; border-radius: 0 6px 6px 0;"><p style="margin: 0; color: #765B2C; font-size: 14px;">${details}</p></div>` : ''}
          <p style="color: #4a5568; line-height: 1.6;">If you have any questions, please don't hesitate to message us through your portal.</p>
          <div style="text-align: center; margin: 28px 0;">
            <a href="${window.location.origin}" style="background: #202326; color: #CBB17B; padding: 12px 28px; border-radius: 6px; text-decoration: none; font-weight: bold; font-size: 15px;">Log In to Your Portal</a>
          </div>
          <hr style="border: none; border-top: 1px solid #e2e8f0; margin: 24px 0;">
          <p style="color: #62615D; font-size: 12px; margin: 0;">Midpoint Accounting Group Co. · info@midpointgroupco.com</p>
        </div>
      </div>
    `
  }),
  document: (clientName, details) => ({
    subject: `Action Required: Documents Needed for Your Tax Return`,
    html: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px;">
        <div style="background: #202326; padding: 24px; border-radius: 8px 8px 0 0; text-align: center;">
          <h1 style="color: #CBB17B; margin: 0; font-size: 24px;">ClearFile Portal</h1>
          <p style="color: rgba(255,255,255,0.6); margin: 4px 0 0; font-size: 13px;">Midpoint Accounting Group Co.</p>
        </div>
        <div style="background: #fff; border: 1px solid #e2e8f0; border-top: none; padding: 32px; border-radius: 0 0 8px 8px;">
          <h2 style="color: #202326; margin-top: 0;">Hello ${clientName},</h2>
          <p style="color: #4a5568; line-height: 1.6;">We are still missing some documents needed to complete your tax return. Please log in to your ClearFile portal and upload the required files at your earliest convenience.</p>
          ${details ? `<div style="background: #F1E8D7; border-left: 4px solid #CBB17B; padding: 12px 16px; margin: 20px 0; border-radius: 0 6px 6px 0;"><p style="margin: 0; color: #765B2C; font-size: 14px;"><strong>Documents needed:</strong><br>${details}</p></div>` : ''}
          <div style="text-align: center; margin: 28px 0;">
            <a href="${window.location.origin}" style="background: #202326; color: #CBB17B; padding: 12px 28px; border-radius: 6px; text-decoration: none; font-weight: bold; font-size: 15px;">Upload Documents Now</a>
          </div>
          <hr style="border: none; border-top: 1px solid #e2e8f0; margin: 24px 0;">
          <p style="color: #62615D; font-size: 12px; margin: 0;">Midpoint Accounting Group Co. · info@midpointgroupco.com</p>
        </div>
      </div>
    `
  }),
  organizer: (clientName, details) => ({
    subject: `Please Complete Your Tax Organizer`,
    html: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px;">
        <div style="background: #202326; padding: 24px; border-radius: 8px 8px 0 0; text-align: center;">
          <h1 style="color: #CBB17B; margin: 0; font-size: 24px;">ClearFile Portal</h1>
          <p style="color: rgba(255,255,255,0.6); margin: 4px 0 0; font-size: 13px;">Midpoint Accounting Group Co.</p>
        </div>
        <div style="background: #fff; border: 1px solid #e2e8f0; border-top: none; padding: 32px; border-radius: 0 0 8px 8px;">
          <h2 style="color: #202326; margin-top: 0;">Hello ${clientName},</h2>
          <p style="color: #4a5568; line-height: 1.6;">Your tax organizer is still incomplete. Please log in to your ClearFile portal and complete the organizer so we can prepare your return accurately and on time.</p>
          ${details ? `<div style="background: #F1E8D7; border-left: 4px solid #CBB17B; padding: 12px 16px; margin: 20px 0; border-radius: 0 6px 6px 0;"><p style="margin: 0; color: #765B2C; font-size: 14px;">${details}</p></div>` : ''}
          <div style="text-align: center; margin: 28px 0;">
            <a href="${window.location.origin}" style="background: #202326; color: #CBB17B; padding: 12px 28px; border-radius: 6px; text-decoration: none; font-weight: bold; font-size: 15px;">Complete Organizer</a>
          </div>
          <hr style="border: none; border-top: 1px solid #e2e8f0; margin: 24px 0;">
          <p style="color: #62615D; font-size: 12px; margin: 0;">Midpoint Accounting Group Co. · info@midpointgroupco.com</p>
        </div>
      </div>
    `
  }),
  invoice: (clientName, details) => ({
    subject: `Invoice Payment Reminder`,
    html: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px;">
        <div style="background: #202326; padding: 24px; border-radius: 8px 8px 0 0; text-align: center;">
          <h1 style="color: #CBB17B; margin: 0; font-size: 24px;">ClearFile Portal</h1>
          <p style="color: rgba(255,255,255,0.6); margin: 4px 0 0; font-size: 13px;">Midpoint Accounting Group Co.</p>
        </div>
        <div style="background: #fff; border: 1px solid #e2e8f0; border-top: none; padding: 32px; border-radius: 0 0 8px 8px;">
          <h2 style="color: #202326; margin-top: 0;">Hello ${clientName},</h2>
          <p style="color: #4a5568; line-height: 1.6;">This is a reminder that you have an outstanding invoice in your ClearFile portal. Please log in to view and pay your invoice at your earliest convenience.</p>
          ${details ? `<div style="background: #F1E8D7; border-left: 4px solid #CBB17B; padding: 12px 16px; margin: 20px 0; border-radius: 0 6px 6px 0;"><p style="margin: 0; color: #765B2C; font-size: 14px;">${details}</p></div>` : ''}
          <div style="text-align: center; margin: 28px 0;">
            <a href="${window.location.origin}" style="background: #202326; color: #CBB17B; padding: 12px 28px; border-radius: 6px; text-decoration: none; font-weight: bold; font-size: 15px;">Pay Invoice Now</a>
          </div>
          <hr style="border: none; border-top: 1px solid #e2e8f0; margin: 24px 0;">
          <p style="color: #62615D; font-size: 12px; margin: 0;">Midpoint Accounting Group Co. · info@midpointgroupco.com</p>
        </div>
      </div>
    `
  }),
  custom: (clientName, details) => ({
    subject: `Message from Midpoint Accounting Group Co.`,
    html: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px;">
        <div style="background: #202326; padding: 24px; border-radius: 8px 8px 0 0; text-align: center;">
          <h1 style="color: #CBB17B; margin: 0; font-size: 24px;">ClearFile Portal</h1>
          <p style="color: rgba(255,255,255,0.6); margin: 4px 0 0; font-size: 13px;">Midpoint Accounting Group Co.</p>
        </div>
        <div style="background: #fff; border: 1px solid #e2e8f0; border-top: none; padding: 32px; border-radius: 0 0 8px 8px;">
          <h2 style="color: #202326; margin-top: 0;">Hello ${clientName},</h2>
          <p style="color: #4a5568; line-height: 1.6; white-space: pre-line;">${details}</p>
          <div style="text-align: center; margin: 28px 0;">
            <a href="${window.location.origin}" style="background: #202326; color: #CBB17B; padding: 12px 28px; border-radius: 6px; text-decoration: none; font-weight: bold; font-size: 15px;">Log In to Your Portal</a>
          </div>
          <hr style="border: none; border-top: 1px solid #e2e8f0; margin: 24px 0;">
          <p style="color: #62615D; font-size: 12px; margin: 0;">Midpoint Accounting Group Co. · info@midpointgroupco.com</p>
        </div>
      </div>
    `
  }),
}

function timeAgo(date) {
  const diff = (new Date() - new Date(date)) / 1000
  if (diff < 60) return 'just now'
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`
  return new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

function Modal({ title, onClose, children }) {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}
      onClick={e => { if (e.target === e.currentTarget) onClose() }}>
      <div className="card animate-fadeUp" style={{ width: '100%', maxWidth: 560, maxHeight: '90vh', overflow: 'auto', padding: 0 }}>
        <div style={{ padding: '18px 22px', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 style={{ fontSize: 17 }}>{title}</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, color: '#62615D', cursor: 'pointer' }}>×</button>
        </div>
        <div style={{ padding: '22px' }}>{children}</div>
      </div>
    </div>
  )
}

export default function RemindersPage() {
  const { profile } = useAuth()
  const [reminders, setReminders] = useState([])
  const [clients, setClients] = useState([])
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [sending, setSending] = useState(false)
  const [success, setSuccess] = useState('')
  const [error, setError] = useState('')
  const [filter, setFilter] = useState('all')

  // Form state
  const [selectedClient, setSelectedClient] = useState('')
  const [reminderType, setReminderType] = useState('deadline')
  const [customSubject, setCustomSubject] = useState('')
  const [details, setDetails] = useState('')
  const [scheduleType, setScheduleType] = useState('now')
  const [scheduledAt, setScheduledAt] = useState('')

  useEffect(() => {
    if (profile?.id) loadData()
  }, [profile?.id])

  async function loadData() {
    try {
      const [{ data: c, error: ce }, { data: r, error: re }] = await Promise.all([
        supabase.from('clients').select('*').eq('cpa_id', profile.id).order('full_name'),
        supabase.from('reminders').select('*').eq('cpa_id', profile.id).order('created_at', { ascending: false })
      ])
      if (ce) console.error('Clients error:', ce)
      if (re) console.error('Reminders error:', re)
      setClients(c || [])
      setReminders(r || [])
    } catch (err) {
      console.error('loadData error:', err)
      setError('Failed to load data: ' + err.message)
    }
    setLoading(false)
  }

  async function sendReminder(e) {
    if (e && e.preventDefault) e.preventDefault()
    setSending(true)
    setError('')

    const client = clients.find(c => c.id === selectedClient)
    if (!client) { setError('Please select a client'); setSending(false); return }

    const clientName = client.business_name || client.full_name
    const template = EMAIL_TEMPLATES[reminderType]
    const { subject, html } = template(clientName, details)
    const finalSubject = reminderType === 'custom' && customSubject ? customSubject : subject

    // Save reminder to DB first
    console.log('DEBUG - profile.id:', profile.id, 'selectedClient:', selectedClient)
    const { data: reminder, error: insertError } = await supabase.from('reminders').insert({
      cpa_id: profile.id,
      created_by: profile.id,
      client_id: selectedClient,
      channel: 'email',
      reminder_type: reminderType,
      message: details,
      scheduled_at: scheduleType === 'now' ? new Date().toISOString() : scheduledAt,
      status: 'pending'
    }).select().single()

    if (insertError) {
      setError('DB Error: ' + insertError.message)
      setSending(false)
      return
    }

    if (scheduleType === 'now') {
      // Send immediately
      const { data: { session } } = await supabase.auth.getSession()
      if (!session?.access_token) {
        setError('Your session expired. Please log in again and retry.')
        setSending(false)
        return
      }

      const res = await fetch('/.netlify/functions/send-reminder', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${session.access_token}`
        },
        body: JSON.stringify({
          subject: finalSubject,
          html,
          reminder_id: reminder?.id
        })
      })
      const data = await res.json()

      if (res.status === 401) {
        setError('Unauthorized. Please sign in again.')
        setSending(false)
        return
      }

      if (res.status === 403) {
        setError(data.error || 'You are not authorized to send this reminder.')
        setSending(false)
        return
      }

      if (data.error) {
        setError('Failed to send: ' + data.error)
        setSending(false)
        return
      }

      // Force update status locally
      if (reminder?.id) {
        await supabase.from('reminders').update({ status: 'sent', sent_at: new Date().toISOString() }).eq('id', reminder.id)
      }
      setSuccess(`Reminder sent to ${client.email}!`)
    } else {
      setSuccess(`Reminder scheduled for ${new Date(scheduledAt).toLocaleDateString()}!`)
    }

    await loadData()
    setShowModal(false)
    setSelectedClient('')
    setReminderType('deadline')
    setDetails('')
    setCustomSubject('')
    setScheduleType('now')
    setScheduledAt('')
    setSending(false)
    setTimeout(() => setSuccess(''), 4000)
  }

  async function deleteReminder(id) {
    await supabase.from('reminders').delete().eq('id', id)
    setReminders(prev => prev.filter(r => r.id !== id))
  }

  async function resendReminder(reminder) {
    setSending(true)
    const client = clients.find(c => c.id === reminder.client_id)
    if (!client) { setSending(false); return }

    const clientName = client.business_name || client.full_name
    const template = EMAIL_TEMPLATES[reminder.reminder_type] || EMAIL_TEMPLATES.custom
    const { subject, html } = template(clientName, reminder.message)

    const { data: { session } } = await supabase.auth.getSession()
    if (!session?.access_token) {
      setError('Your session expired. Please log in again and retry.')
      setSending(false)
      return
    }

    const res = await fetch('/.netlify/functions/send-reminder', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`
      },
      body: JSON.stringify({ subject, html, reminder_id: reminder.id })
    })
    const data = await res.json()

    if (res.status === 401) {
      setError('Unauthorized. Please sign in again.')
      setSending(false)
      return
    }

    if (res.status === 403) {
      setError(data.error || 'You are not authorized to resend this reminder.')
      setSending(false)
      return
    }

    if (data.error) { setError('Failed to resend: ' + data.error) }
    else { setSuccess(`Resent to ${client.email}!`); await loadData() }

    setSending(false)
    setTimeout(() => setSuccess(''), 4000)
  }

  const filtered = filter === 'all' ? reminders : reminders.filter(r => r.status === filter)
  const sentCount = reminders.filter(r => r.status === 'sent').length
  const scheduledCount = reminders.filter(r => r.status === 'scheduled').length

  if (loading) return (
    <div style={{ display: 'grid', gap: 10 }}>
      {[...Array(3)].map((_, i) => <div key={i} className="skeleton" style={{ height: 72 }} />)}
    </div>
  )

  return (
    <div>
      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginBottom: 24 }}>
        {[
          { label: 'Total Sent', value: sentCount, color: '#10B981', icon: '✅' },
          { label: 'Scheduled', value: scheduledCount, color: '#CBB17B', icon: '🕐' },
          { label: 'Total Reminders', value: reminders.length, color: '#6366F1', icon: '🔔' },
        ].map((s, i) => (
          <div key={i} className="card animate-fadeUp" style={{ padding: '16px 18px', position: 'relative', overflow: 'hidden' }}>
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 3, background: s.color }} />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>
                <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 22, fontWeight: 700 }}>{s.value}</div>
                <div style={{ fontSize: 12, color: '#62615D', marginTop: 2 }}>{s.label}</div>
              </div>
              <span style={{ fontSize: 22, opacity: 0.6 }}>{s.icon}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <div style={{ display: 'flex', gap: 8 }}>
          {['all', 'sent', 'scheduled'].map(f => (
            <button key={f} onClick={() => setFilter(f)}
              className={filter === f ? 'btn btn-primary' : 'btn btn-ghost'}
              style={{ padding: '6px 14px', fontSize: 12, textTransform: 'capitalize' }}>
              {f}
            </button>
          ))}
        </div>
        <button className="btn btn-primary" onClick={() => setShowModal(true)}>
          + Send Reminder
        </button>
      </div>

      {/* Success/error messages */}
      {success && (
        <div style={{ background: '#D1FAE5', border: '1px solid #6EE7B7', borderRadius: 8, padding: '10px 16px', marginBottom: 16, fontSize: 13, color: '#065F46', fontWeight: 600 }}>
          ✅ {success}
        </div>
      )}
      {error && (
        <div style={{ background: '#FEE2E2', border: '1px solid #F87171', borderRadius: 8, padding: '10px 16px', marginBottom: 16, fontSize: 13, color: '#991B1B' }}>
          ⚠️ {error}
        </div>
      )}

      {/* Reminders list */}
      {filtered.length === 0 ? (
        <div className="card" style={{ padding: '48px', textAlign: 'center' }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🔔</div>
          <h3 style={{ marginBottom: 8 }}>No reminders yet</h3>
          <p style={{ color: '#62615D', fontSize: 13, marginBottom: 20 }}>Send your first reminder to a client</p>
          <button className="btn btn-primary" onClick={() => setShowModal(true)}>+ Send Reminder</button>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: 10 }}>
          {filtered.map(r => {
            const typeInfo = REMINDER_TYPES.find(t => t.value === r.reminder_type) || REMINDER_TYPES[4]
            const rc = clients.find(c => c.id === r.client_id)
            const clientName = rc?.business_name || rc?.full_name || 'Unknown'
            return (
              <div key={r.id} className="card" style={{ padding: '14px 18px', display: 'flex', alignItems: 'center', gap: 14 }}>
                <div style={{ width: 42, height: 42, borderRadius: 10, background: r.status === 'sent' ? '#D1FAE5' : '#F1E8D7', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, flexShrink: 0 }}>
                  {typeInfo.label.split(' ')[0]}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: '#202326' }}>{clientName}</div>
                  <div style={{ fontSize: 12, color: '#62615D' }}>{typeInfo.label.split(' ').slice(1).join(' ')} · {rc?.email}</div>
                  {r.message && <div style={{ fontSize: 12, color: '#4a5568', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.message}</div>}
                </div>
                <div style={{ textAlign: 'right', flexShrink: 0 }}>
                  <span className={`badge badge-${r.status === 'sent' ? 'success' : r.status === 'scheduled' ? 'warning' : 'neutral'}`} style={{ fontSize: 10, display: 'block', marginBottom: 4 }}>
                    {r.status === 'sent' ? '✓ Sent' : r.status === 'pending' && r.scheduled_at > new Date().toISOString() ? '🕐 Scheduled' : r.status}
                  </span>
                  <div style={{ fontSize: 11, color: '#62615D' }}>
                    {r.sent_at ? timeAgo(r.sent_at) : r.scheduled_at ? new Date(r.scheduled_at).toLocaleDateString() : timeAgo(r.created_at)}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                  <button className="btn btn-ghost" style={{ fontSize: 11, padding: '5px 10px' }} onClick={() => resendReminder(r)} disabled={sending}>
                    Resend
                  </button>
                  <button onClick={() => deleteReminder(r.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#F87171', fontSize: 16, padding: '4px 6px' }}>×</button>
                </div>
              </div>
            )
          })}
        </div>
      )}

      {/* Send reminder modal */}
      {showModal && (
        <Modal title="Send Reminder" onClose={() => setShowModal(false)}>
          <form onSubmit={sendReminder}>
            {/* Client select */}
            <div style={{ marginBottom: 16 }}>
              <label className="label">Client *</label>
              <select className="input" value={selectedClient} onChange={e => setSelectedClient(e.target.value)} required>
                <option value="">Select a client…</option>
                {clients.map(c => (
                  <option key={c.id} value={c.id}>{c.business_name || c.full_name} ({c.email})</option>
                ))}
              </select>
            </div>

            {/* Reminder type */}
            <div style={{ marginBottom: 16 }}>
              <label className="label">Reminder Type *</label>
              <div style={{ display: 'grid', gap: 8 }}>
                {REMINDER_TYPES.map(t => (
                  <label key={t.value} style={{
                    display: 'flex', alignItems: 'flex-start', gap: 10, padding: '10px 12px',
                    borderRadius: 8, border: `1.5px solid ${reminderType === t.value ? '#CBB17B' : 'var(--border)'}`,
                    background: reminderType === t.value ? '#F1E8D7' : '#fff', cursor: 'pointer'
                  }}>
                    <input type="radio" name="type" value={t.value} checked={reminderType === t.value}
                      onChange={() => setReminderType(t.value)} style={{ marginTop: 2 }} />
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 600 }}>{t.label}</div>
                      <div style={{ fontSize: 11, color: '#62615D' }}>{t.desc}</div>
                    </div>
                  </label>
                ))}
              </div>
            </div>

            {/* Custom subject */}
            {reminderType === 'custom' && (
              <div style={{ marginBottom: 16 }}>
                <label className="label">Subject</label>
                <input className="input" placeholder="Email subject line" value={customSubject} onChange={e => setCustomSubject(e.target.value)} />
              </div>
            )}

            {/* Details / message */}
            <div style={{ marginBottom: 16 }}>
              <label className="label">{reminderType === 'custom' ? 'Message *' : 'Additional Details (optional)'}</label>
              <textarea className="input" rows={3} style={{ resize: 'vertical' }}
                placeholder={reminderType === 'custom' ? 'Write your message to the client…' : 'Add any specific details or notes…'}
                value={details} onChange={e => setDetails(e.target.value)}
                required={reminderType === 'custom'} />
            </div>

            {/* Schedule */}
            <div style={{ marginBottom: 20 }}>
              <label className="label">When to Send</label>
              <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                {[{ value: 'now', label: '📤 Send Now' }, { value: 'schedule', label: '🕐 Schedule' }].map(s => (
                  <button key={s.value} type="button"
                    onClick={() => setScheduleType(s.value)}
                    className={scheduleType === s.value ? 'btn btn-primary' : 'btn btn-ghost'}
                    style={{ flex: 1, justifyContent: 'center', fontSize: 13 }}>
                    {s.label}
                  </button>
                ))}
              </div>
              {scheduleType === 'schedule' && (
                <input type="datetime-local" className="input"
                  value={scheduledAt} onChange={e => setScheduledAt(e.target.value)}
                  min={new Date().toISOString().slice(0, 16)} required />
              )}
            </div>

            <div style={{ display: 'flex', gap: 10 }}>
              <button type="button" className="btn btn-ghost" onClick={() => setShowModal(false)}>Cancel</button>
              <button type="button" className="btn btn-primary" disabled={sending} style={{ flex: 1, justifyContent: 'center' }}
                onClick={sendReminder}>
                {sending ? 'Sending…' : scheduleType === 'now' ? '📤 Send Now' : '🕐 Schedule Reminder'}
              </button>
            </div>
          </form>
        </Modal>
      )}
    </div>
  )
}
